import React, { Component } from "react";
import Dropzone from 'react-dropzone';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Growl } from 'primereact/growl';
import {Dialog} from 'primereact/dialog';

import servicioHttp from '../../servicio/ServicioHttp';
import logo_upload from '../../../src/componentes/Image/subir_archivos.png'


export class SubirXmlNomina extends Component {
  constructor() {
    super();
    this.state = {
      archivos: [],
      listadoArchivos: [],
      confirmacion:false,
      respuesta:''
    };
  }

  onDrop = (files) => {
    var formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      var cfdi = files[i];
      formData.append('xmlOrZip', cfdi);
    }
    this.setState({ archivos: formData, listadoArchivos: files.length });
  };


  guardarXml = () => {
    let { archivos } = this.state;
    servicioHttp
      .consumirPostHttp("/movimientos/procesar.json", archivos)
      .then(response => {
          this.setState({confirmacion:true,archivos: [],listadoArchivos: [],respuesta:response.data.mensaje});
        
      }).catch((error) => {
        this.growl.show({
            severity: "error", summary: "", detail: "Se genero un error no esperado, por favor inténtelo de nuevo",
        });
    });
  }

  cerrarModalConfirmacion=()=>{
    this.setState({confirmacion:false});
  }
  render() {
    let { listadoArchivos,respuesta } = this.state;
    
    const dialogFooter = (
      <div>
          <Button icon="pi pi-check" onClick={this.cerrarModalConfirmacion} label="Enterado" />
       
      </div>
  );

    return <div className="p-grid">

    <Growl ref={(el) => this.growl = el} />

      <Card className="p-col-12 p-md-12">
        <h1 style={{ textAlign: 'center', fontSize: '30px', fontWeight: 'bolder' }} >SUBIR XML's NÓMINA</h1>
      </Card>

      <div className="p-col-12 p-md-12" style={{ marginTop: "15px" }}>
        <Dropzone accept=".xml,.zip" onDrop={this.onDrop} maxSize={10000000000}>
          {({ getRootProps, getInputProps }) => (
            <section >
              <center>
              <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                <input   {...getInputProps()} />
                <div style={{display:'flex', justifyContent:'center'}}><img className="rectangulo-img-upload" src={logo_upload} alt='upload'/></div>
                <center><p style={{marginBottom:'2rem', marginLeft:'15px', marginRight:'15px'}}><i>Arrastra tus archivos xml's,zip o haz click aquí</i></p></center>
              </div>
              </center>
              <br />
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-lg-5"></div>
                <div className="p-col-12 p-lg-4">
                  <h1>Archivos a procesar: {listadoArchivos}</h1>

                </div>
                <br />
                <div className="p-col-12 p-lg-4"></div>
                <div className="p-col-12 p-lg-4">
                  <Button icon='pi pi-upload' label="Guardar Xml's" onClick={this.guardarXml} />
                </div>
              </div>
            </section>
          )}
        </Dropzone>
      </div>

      <Dialog header="Confirmación" visible={this.state.confirmacion} modal={true} width="400px" footer={dialogFooter} onHide={this.cerrarModalConfirmacion}>
          <p>{respuesta}</p>
       </Dialog>
    </div>
  }
}